import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { OLD_BULK_BATCHES_THRESHOLD_IN_DAYS } from "../constants";

export const selectorIsOldImportBatch = (batch?: Batch): boolean => {
  const createdAt = batch?.events?.createdAt;
  if (!createdAt) {
    return false;
  }

  const threshold = new Date();
  threshold.setDate(threshold.getDate() - OLD_BULK_BATCHES_THRESHOLD_IN_DAYS);

  return new Date(createdAt) < threshold;
};
